import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NexusImportWarning } from "../hooks/WebSocketProvider";

/** `${filterId}_${yyyy-MM-dd}` — the cell the warnings belong to. */
export const importValidationWarningsKey = (filter: string, date: string) =>
  `${filter}_${date.split("T")[0]}`;

/**
 * Warnings about repaired Nexus import data, waiting for the user to acknowledge them. Kept per cell so a warning
 * that arrives before the user has navigated to the cell is still shown once they get there.
 */
const importValidationWarningsSlice = createSlice({
  name: "importValidationWarnings",
  initialState: {} as Record<string, NexusImportWarning[]>,
  reducers: {
    setImportValidationWarnings(
      state,
      action: PayloadAction<{
        filter: string;
        date: string;
        warnings: NexusImportWarning[];
      }>,
    ) {
      const { filter, date, warnings } = action.payload;
      state[importValidationWarningsKey(filter, date)] = warnings;
    },
    acknowledgeImportValidationWarnings(state, action: PayloadAction<string>) {
      delete state[action.payload];
    },
  },
});

export const {
  setImportValidationWarnings,
  acknowledgeImportValidationWarnings,
} = importValidationWarningsSlice.actions;
export default importValidationWarningsSlice.reducer;
